// extracted by mini-css-extract-plugin
export default {"container":"nav_user_dropdown_link-module__container--2og2a"};